import { useEffect, useState } from "react";
import ImageWithTransition from "components/Elements/ImageWithTransition";
import MetaTags from "components/MetaTags";
import { Container } from "components/Elements/Container";
import { OneColumn, TwoColumns, TwoRows } from "components/ProjectAssets";
import Plyr from "plyr";
import { ProjectCard } from "components/GridCards";
import API from "strapi/api";
import parse from "html-react-parser";

const Slug = (props) => {
  const [hasControl, setHasControl] = useState(false);

  const [video, setVideo] = useState({
    id: props?.content?.cover_media[0]?.video_id
      ? props.content.cover_media[0].video_id
      : "",
  });

  const getIdFromUrl = (url) => {
    const splittedUrl = url.split("/");
    const id = splittedUrl.filter((key) => key && !isNaN(key))[0];

    return id;
  };

  useEffect(() => {
    const controls = document.querySelector(".vp-player-ui-overlays");
    if (!hasControl) {
    }
  }, [hasControl]);

  useEffect(() => {
    const videos = props.content.gallery.filter(
      (item) => item.__component === "general.video-gallery",
    );

    const players = Array.from(document.querySelectorAll(".plyr-players")).map(
      (player) => {
        const isHero = player.dataset.isHero === "true";
        const hasAutoplay = player.dataset.autoplay === "true";

        const newPlyr = new Plyr(player, {
          title: `${props.content.title} video`,
          storage: { enabled: false },
          controls: ["play-large", "progress", "mute", "volume", "fullscreen"],
          clickToPlay: true,
          autopause: true,
          autoplay: hasAutoplay ? true : false,
          muted: false,
          loop: { active: false },
          vimeo: {
            byline: false,
            portrait: false,
            title: false,
            speed: false,
            transparent: false,
            controls: true,
          },
          ratio: null,
          fullscreen: { iosNative: true },
        });

        return newPlyr;
      },
    );

    return () => {
      players.map((player) => {
        // player.destroy()
      });
    };
  }, []);

  return (
    <main>
      <MetaTags
        title={
          props.content && props.content.title ? props.content.title + "" : ""
        }
        description={
          props.content.meta_info && props.content.meta_info.meta_description
            ? props.content.meta_info.meta_description
            : props.content.title
        }
        image={
          props.content.meta_info && props.content.og_image
            ? API.getNextImage(props.content.meta_info.og_image)
            : ""
        }
      />
      <div>
        <h1 className="offscreen-title">{props.content.title}</h1>
        <div className="bg-black 768:mb-8">
          {props?.content?.cover_media[0] &&
          props.content.cover_media[0].image ? (
            <div className="image-container">
              <ImageWithTransition
                src={API.getNextImage(props.content.cover_media[0].image)}
                layout="fill"
                objectFit="cover"
                alt=""
              />
            </div>
          ) : (
            <div
              id="hero-player"
              data-autoplay="true"
              data-is-hero="true"
              className="plyr-players hero"
            >
              <iframe
                src={`https://player.vimeo.com/video/${getIdFromUrl(video.id)}`}
                allowtransparency="true"
                allow="autoplay"
              ></iframe>
            </div>
          )}
        </div>

        <Container>
          <section
            id="project-details"
            className="grid col-span-6 gap-3 991:grid-cols-12 991:gap-5 gap-y-0"
          >
            <div className="col-span-12 row-span-2 mb-5 991:col-span-8">
              <div className="text-20 991:text-52 leading-[1.15] content-with-glyphs">
                {parse(props.content.content)}
              </div>
            </div>

            <div className="col-span-12 row-start-1 mt-4 991:col-span-3 1366:col-span-2 991:col-start-10 1366:col-start-11 h-max">
              <h2 className="mb-5 leading-none uppercase text-18 991:text-30 991:mb-4">
                {props.content.title}
              </h2>
            </div>

            <div className="col-span-12 leading-tight uppercase 991:col-span-3 1366:col-span-2 991:col-start-10 1366:col-start-11 text-16 768:text-18 1280:text-22">
              {props.content.details ? (
                props.content.details.map((detail, i) => {
                  return (
                    <div className="flex flex-col mb-4" key={i}>
                      {detail.title ? <span>{detail.title}</span> : <></>}

                      {detail.value ? <span>{detail.value}</span> : <></>}
                    </div>
                  );
                })
              ) : (
                <></>
              )}
              {props.content.year ? <span>{props.content.year}</span> : <></>}
            </div>
          </section>

          {props.content.gallery ? (
            <section
              id="project-assets-grid"
              className="grid grid-cols-2 gap-1 mt-8 640:gap-5"
            >
              {props.content.gallery.map((item, index) => {
                if (item.__component == "general.50-50-images") {
                  return (
                    <TwoColumns
                      key={index}
                      sources={[
                        API.getNextImage(item.left_image),
                        API.getNextImage(item.right_image),
                      ]}
                    />
                  );
                }
                if (item.__component == "general.full-width-image") {
                  return (
                    <OneColumn
                      key={index}
                      source={API.getNextImage(item.full_image)}
                    />
                  );
                }
                if (
                  item.__component ==
                  "general.grid-1-vertical-image-2-horizontal-images"
                ) {
                  return (
                    <TwoRows
                      key={index}
                      sources={[
                        API.getNextImage(item.vertical_image),
                        API.getNextImage(item.first_right_image),
                        API.getNextImage(item.second_right_image),
                      ]}
                    />
                  );
                }
                if (item.__component == "general.video-gallery") {
                  return item.autoplay ? (
                    <div className="col-span-2" key={index}>
                      <video
                        preload="metadata"
                        className="w-full"
                        autoPlay
                        muted
                        playsInline
                        loop
                      >
                        <source src={item.vimeo_url} type="video/mp4" />
                      </video>
                    </div>
                  ) : (
                    <div className="col-span-2" key={index}>
                      <div className="plyr-players" data-autoplay="false">
                        <iframe
                          className="w-full"
                          src={`https://player.vimeo.com/video/${getIdFromUrl(
                            item.vimeo_url,
                          )}`}
                          allowtransparency="true"
                          allow="autoplay"
                        ></iframe>
                      </div>
                    </div>
                  );
                }
                if (item.__component == "general.video-50-50") {
                  return (
                    <>
                      {item.left_video && (
                        <div className="col-span-1">
                          {item.autoplay_left ? (
                            <video
                              autoPlay
                              muted
                              playsInline
                              loop
                              src={item.left_video}
                            ></video>
                          ) : (
                            <div className="plyr-players" data-autoplay="false">
                              <iframe
                                className="w-full"
                                src={`https://player.vimeo.com/video/${getIdFromUrl(
                                  item.left_video,
                                )}`}
                                allowtransparency="true"
                                allow="autoplay"
                              ></iframe>
                            </div>
                          )}
                        </div>
                      )}
                      {item.right_video && (
                        <div className="col-span-1">
                          {item.autoplay_right ? (
                            <video
                              autoPlay
                              muted
                              playsInline
                              loop
                              src={item.right_video}
                            ></video>
                          ) : (
                            <div className="plyr-players" data-autoplay="false">
                              <iframe
                                className="w-full"
                                src={`https://player.vimeo.com/video/${getIdFromUrl(
                                  item.right_video,
                                )}`}
                                allowtransparency="true"
                                allow="autoplay"
                              ></iframe>
                            </div>
                          )}
                        </div>
                      )}
                    </>
                  );
                }
              })}
            </section>
          ) : (
            <></>
          )}

          {props.otherWork.length ? (
            <section className="mt-8 mb-2 768:mb-11">
              <h2 className="font-thin leading-none uppercase fluid-type">
                more work
              </h2>
              <div className="grid grid-cols-1 mt-6 768:grid-cols-12 gap-x-5 gap-y-2 768:gap-5">
                {props.otherWork.map((project, index) => {
                  return (
                    <ProjectCard
                      projectLink={"/work/" + project.attributes.slug}
                      imageUrl={API.getNextImage(project.attributes.thumbnail)}
                      title={project.attributes.title}
                      client={project.attributes.client}
                      year={project.attributes.year}
                      key={index}
                    />
                  );
                })}
              </div>
            </section>
          ) : (
            <></>
          )}
        </Container>
      </div>
    </main>
  );
};

export default Slug;

// Slug.getInitialProps = async ctx => {
//     const slug = ctx.query.slug

//     let [work, otherWork] = await Promise.all([API.getSingleBySlug('works', slug), API.getOtherWorks(slug)])

//     return work ? { content: work, otherWork: otherWork } : { statusCode: 404 }
// }

export async function getStaticPaths() {
  let projects = await API.getWork("");

  return {
    // paths: projects.map((project) => ({
    //   params: {
    //     slug: project.slug,
    //   },
    // })),
    paths: [],
    fallback: "blocking",
  };
}

export async function getStaticProps(ctx) {
  const slug = ctx.params.slug;

  let [work, otherWork] = await Promise.all([
    API.getSingleBySlug("works", slug),
    API.getOtherWorks(slug),
  ]);

  return { props: { content: work, otherWork: otherWork }, revalidate: 10 };
}
